import { render, staticRenderFns } from "./ProductFeatures.vue?vue&type=template&id=2dd7a11a"
import script from "./ProductFeatures.vue?vue&type=script&lang=js"
export * from "./ProductFeatures.vue?vue&type=script&lang=js"
import style0 from "./ProductFeatures.vue?vue&type=style&index=0&id=2dd7a11a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports